import  { useEffect, useRef, useState } from 'react';
import './Carousel.css';

const INFO_BLOCKS_DETAILS_1 = [
  {
    title: "Unified Liquidity",
    description:
      "LPs deposit into a single vault and provide liquidity to all markets",
      imageUrl:'/images/dynamic-liquidity/unified-liquidity.png'
  },
  {
    title: "Atomic Arbitrage Opportunities",
    description:
      "RFX will leverage integrated precompiles enabling efficient funding-rate arbitrage between RFX and HL core.",
      imageUrl:'/images/dynamic-liquidity/atomic-arbitrage.png'
  },
  {
    title: "Zero-Slippage Execution",
    description: "Instantly execute size on major assets without price impact.",
    imageUrl:'/images/dynamic-liquidity/zero-liquidity.png'
  },
  {
    title: "Native Pair Trading",
    description:
      "Trade two pairs with a single position and a single funding rate.",
      imageUrl:'/images/dynamic-liquidity/native-paring.png'
  },
];

const INFO_BLOCKS_DETAILS_2 = [
      {
    title: "Diverse Collateral Options",
    description:
      "Use native ecosystem assets (e.g., stHype, uBTC, PURR, feUSD) for trading and liquidity provisioning.",
      imageUrl:'/images/dynamic-liquidity/diverse-collateral.png'
  },
  {
    title: "Create Your Own Perp Markets",
    description:
      "Deploy and fund your own liquidity pool for any market permissionlessly and free of cost.",
      imageUrl:'/images/dynamic-liquidity/own-perp-markets.png'
  },
  {
    title: "Fair Pricing",
    description:
      "RFX uses the median price from top exchanges to give you the best prices eliminating scam liquidation wicks",
      imageUrl:'/images/dynamic-liquidity/fair-pricing.png'
  },
   {
    title: "HypeAligned",
    description:
      "Share of protocol revenue goes to HLP",
      imageUrl:'/images/dynamic-liquidity/hyperaligned.png'
  },
]

const AutoCarousel = () => {
  const trackRef = useRef(null);
  const [index, setIndex] = useState(0);
  const totalItems = 3; // 2 real + 1 duplicate
  const slideWidth = window.innerWidth;

  // Touch swipe tracking
  const startX = useRef(0);
  const isDragging = useRef(false);
  const currentTranslate = useRef(0);

  const swipeToIndex = (newIndex) => {
    if (trackRef.current) {
      trackRef.current.style.transition = 'transform 0.8s ease';
      trackRef.current.style.transform = `translateX(-${slideWidth * newIndex}px)`;
    }

    if (newIndex === totalItems - 1) {
      setTimeout(() => {
        if (trackRef.current) {
          trackRef.current.style.transition = 'none';
          trackRef.current.style.transform = `translateX(0px)`;
        }
        setIndex(0);
      }, 800);
    }

    setIndex(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      swipeToIndex((index + 1) % totalItems);
    }, 20000);

    return () => clearInterval(interval);
  }, [index, slideWidth]);

  // Touch handlers
  const handleTouchStart = (e) => {
    isDragging.current = true;
    startX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    if (!isDragging.current) return;
    const currentX = e.touches[0].clientX;
    const diff = currentX - startX.current;

    if (trackRef.current) {
      trackRef.current.style.transition = 'none';
      currentTranslate.current = -index * slideWidth + diff;
      trackRef.current.style.transform = `translateX(${currentTranslate.current}px)`;
    }
  };

  const handleTouchEnd = () => {
    isDragging.current = false;
    const movedBy = currentTranslate.current + index * slideWidth;

    if (movedBy < -50 && index < totalItems - 1) {
      swipeToIndex(index + 1);
    } else if (movedBy > 50 && index > 0) {
      swipeToIndex(index - 1);
    } else {
      swipeToIndex(index); // snap back
    }
  };

  return (
    <div className="carousel my-4 overflow-hidden touch-pan-x">
      <div
        className="carousel-track flex"
        ref={trackRef}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div className="carousel-item px-6 w-full shrink-0">
          <MobileSlide2Info list={INFO_BLOCKS_DETAILS_1} />
        </div>
        <div className="carousel-item px-6 w-full shrink-0">
          <MobileSlide2Info list={INFO_BLOCKS_DETAILS_2} />
        </div>
        <div className="carousel-item px-6 w-full shrink-0">
          <MobileSlide2Info list={INFO_BLOCKS_DETAILS_1} />
        </div>
      </div>
    </div>
  );
};


export default AutoCarousel;

const MobileSlide2Info = ({list}) => {
 return(
    <div>
          {list.map((info) => (
            <MobileInfoBlock
            imageUrl={info.imageUrl}
              key={info.title}
              title={info.title}
              description={info.description}
            />
          ))}
    </div>
 )
}

const MobileInfoBlock = ({ title, description, imageUrl }) => {
  return (
    <div className="flex items-center justify-between gap-4 pb-6">
      <img src={imageUrl} alt="" className="!w-14 !h-14" />
      <div className="flex-1 flex flex-col gap-1 text-left">
        <div className="text-[#51D2C1] text-base font-medium font-noto-sans-thai">
          {title}
        </div>
        <div className="text-sm font-medium text-white font-noto-sans-thai">
          {description}
        </div>
      </div>
    </div>
  );
};